// removed by extract-text-webpack-plugin
module.exports = {"loader":"_2XXCF5y7mjJ3H-vxR04uqN","circle":"_36cwx5KzR_r8tJapLEuI76"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Loader/Loader.css
// module id = 446
// module chunks = 0